module.exports = __webpack_public_path__ + "media/sand.44754b52.svg";